// Registry dos painéis do envolvido. `key` casa com involved.panels.key (BD).
import RegulationPanel from './RegulationPanel.vue'
import VitalSignsPanel from './VitalSignsPanel.vue'
import IntercurrencesPanel from './IntercurrencesPanel.vue'
import AssessmentPanel from './AssessmentPanel.vue'
import ProblemsPanel from './ProblemsPanel.vue'
import NeurologicalAssessmentPanel from './NeurologicalAssessmentPanel.vue'
import PrescriptionsPanel from './PrescriptionsPanel.vue'
import DiagnosticHypothesisPanel from './DiagnosticHypothesisPanel.vue'
import EvolutionPanel from './EvolutionPanel.vue'
import OutcomePanel from './OutcomePanel.vue'
import DestinationPanel from './DestinationPanel.vue'
import NotesPanel from './NotesPanel.vue'
import CareLinePanel from './CareLinePanel.vue'

export const PANEL_COMPONENTS = {
  regulation: RegulationPanel,
  vital_signs: VitalSignsPanel,
  intercurrences: IntercurrencesPanel,
  assessment: AssessmentPanel,
  problems: ProblemsPanel,
  neurological_assessment: NeurologicalAssessmentPanel,
  prescriptions: PrescriptionsPanel,
  diagnostic_hypothesis: DiagnosticHypothesisPanel,
  destination: DestinationPanel,
  evolution: EvolutionPanel,
  outcome: OutcomePanel,
  notes: NotesPanel,
  care_line: CareLinePanel,
  // custom_forms NÃO entra aqui: cada formulário vira sua própria aba dinâmica,
  // expandida/renderizada diretamente por InvolvedClinicalCard.vue (ver método
  // loadCustomForms/currentCustomForm) — não é um componente único de painel.
}

// Rótulo/ícone de fallback (quando o papel não traz os painéis do BD).
export const PANEL_META = {
  regulation: { label: 'Regulação Inicial', icon: 'FileTextIcon' },
  care_line: { label: 'Linha de Cuidado', icon: 'HeartIcon' },
  vital_signs: { label: 'Sinais Vitais', icon: 'HeartIcon' },
  intercurrences: { label: 'Intercorrências', icon: 'AlertTriangleIcon' },
  assessment: { label: 'Avaliação Inicial', icon: 'ClipboardIcon' },
  problems: { label: 'Problemas', icon: 'AlertCircleIcon' },
  neurological_assessment: { label: 'Avaliação Neurológica', icon: 'ActivityIcon' },
  prescriptions: { label: 'Prescrições', icon: 'DropletIcon' },
  diagnostic_hypothesis: { label: 'Hipótese Diagnóstica', icon: 'CrosshairIcon' },
  destination: { label: 'Destino', icon: 'MapPinIcon' },
  evolution: { label: 'Conduta / Evolução', icon: 'BookOpenIcon' },
  outcome: { label: 'Desfecho', icon: 'FlagIcon' },
  notes: { label: 'Anotações', icon: 'MessageSquareIcon' },
}

// Conjunto clínico completo — fallback para pessoa sem papel/painéis (legado).
// Mantém a ordem canônica das abas (ver InvolvedRoleSeeder no backend).
export const CLINICAL_FALLBACK = [
  'regulation', 'assessment', 'vital_signs', 'problems', 'neurological_assessment', 'evolution', 'prescriptions', 'diagnostic_hypothesis', 'destination', 'intercurrences', 'outcome',
]
